import { ChangeEvent } from "react";
import { copy } from "shared/assets";
import { IFieldType, IFileType, IFormFields } from "shared/types";

const { fileProperties, fileForm, errors } = copy;

export const getFormFields = ({
  onTitleChange,
  onFileChange,
}: {
  onTitleChange: (title: string) => void;
  onFileChange: (fileName: File) => void;
}): IFormFields => {
  const handleTitleChange = ({ target }: ChangeEvent<HTMLInputElement>) =>
    target && onTitleChange(target.value);

  return [
    {
      name: "file",
      label: fileProperties.file.title,
      type: IFieldType.file,
      validation: {
        required: errors.required,
        type: {
          types: [...Object.values(IFileType)],
          message: fileForm.validation.type,
        },
        fileSize: {
          maxSize: 31457280, // 30 MB
          message: fileForm.validation.fileSize,
        },
      },
      handleFileChange: (fileName: File) => onFileChange(fileName),
    },
    {
      name: "title",
      label: fileProperties.title.title,
      type: IFieldType.text,
      validation: {
        required: errors.required,
      },
      onChange: handleTitleChange,
    },
    {
      name: "description",
      label: fileProperties.description.title,
      type: IFieldType.textarea,
    },
  ];
};
